import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_STATUS,
  COLUMN_TYPE,
  COLUMN_ACTIVITY_TYPE,
  COLUMN_ATTRIBUTION,
  COLUMN_USAGE_LIMIT,
  COLUMN_CONDITION_REWARDS,
  COLUMN_GG_CAMPAIGNS,
  COLUMN_ACTIVITY_PERIOD,
  COLUMN_REDEEMED,
  COLUMN_APPLICATION,
  COLUMN_PLATFORMS,
  COLUMN_COUNTRIES,
  COLUMN_EXCLUDED_COUNTRIES,
  COLUMN_REQUESTED_BY,
  COLUMN_UPDATED_BY,
  COLUMN_UPDATED_DATE,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/PromoCodes/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_STATUS,
    COLUMN_TYPE,
    COLUMN_ACTIVITY_TYPE,
    COLUMN_ATTRIBUTION,
    COLUMN_USAGE_LIMIT,
    COLUMN_CONDITION_REWARDS,
    COLUMN_GG_CAMPAIGNS,
    COLUMN_ACTIVITY_PERIOD,
    COLUMN_REDEEMED,
    COLUMN_APPLICATION,
    COLUMN_PLATFORMS,
    COLUMN_COUNTRIES,
    COLUMN_EXCLUDED_COUNTRIES,
    COLUMN_REQUESTED_BY,
    COLUMN_UPDATED_BY,
    COLUMN_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
